import { Progress } from "../types";

export const getProgressCount = (progress: Progress) => {
    return ((progress.count / (progress.total || 100)) * 100);
}